import React from 'react';
import styles from '../ChatWidget.module.scss';

export default function TypingIndicator() {
  return (
    <div className={`${styles.messageRow} ${styles.messageRowAssistant}`}>
      <div className={styles.bubbleAvatar}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="4" width="18" height="14" rx="3" stroke="#64748B" strokeWidth="1.5" />
          <circle cx="9" cy="10" r="1.5" fill="#64748B" />
          <circle cx="15" cy="10" r="1.5" fill="#64748B" />
          <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </div>
      <div className={styles.typingIndicator} data-testid="chat-typing-indicator">
        <span className={styles.typingDot} />
        <span className={styles.typingDot} />
        <span className={styles.typingDot} />
      </div>
    </div>
  );
}
